import { COMMA, ENTER } from "@angular/cdk/keycodes";
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
import { MatChipInputEvent } from "@angular/material/chips";
import { Store } from "@ngrx/store";
import {
  BranchService
} from "blg-akaun-ts-lib";
import { PermissionStates } from "../../modules/permission/permission-controller/root";
import { UserPermInquirySelectors } from "../../modules/permission/user-permissions-inquiry-controller/selectors";
import { DropDownService } from "../../services/drop-down-service";
import { AppConfig } from "../../visa";
import { Observable } from "rxjs";
import {
  debounceTime,
  distinctUntilChanged,
  map
} from "rxjs/operators";
import { SubSink } from "subsink2";

@Component({
  selector: "app-branch",
  templateUrl: "./branch.component.html",
  styleUrls: ["./branch.component.css"],
})
export class BranchComponent implements OnInit, OnDestroy {
  @Input() branchControl = new FormControl();
  @Output() selectionChange = new EventEmitter();
  @Input() viewModelStore;
  @Input() ColumnViewActions;
  @Input() ColumnViewSelectors;
  @Input() readPermissionDefintion;

  userPermissionTarget$ = this.permissionStore.select(
    UserPermInquirySelectors.selectUserPermInquiry
  );

  private subs = new SubSink();
  separatorKeysCodes: number[] = [ENTER, COMMA];
  filteredBranches$: Observable<any[]>;
  branches: any[] = [];
  allBranches: any[] = [];
  toppingsControl = new FormControl([]);
  filteredBranches: any[] = [];
  newFilteredBranches: any[] = [];

  @ViewChild("branchInput") branchInput: ElementRef<HTMLInputElement>;
  branchTargets: string[]=[];

  constructor(
    private branchService: BranchService,
    private readonly permissionStore: Store<PermissionStates>,
    private dropDownService: DropDownService
  ) {}

  ngOnInit(): void {
    this.viewModelStore
      .select(this.ColumnViewSelectors.selectAdvanceSearch_Branch_Field)
      .subscribe((data) => {
        this.branches = data;
      });

    this.branchControl.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((data) => this.filterBranch(data));

    this.subs.sink = this.userPermissionTarget$.subscribe((targets) => {
      let target = targets.filter(
        (target) => target.permDfn === this.readPermissionDefintion
      );
      this.branchTargets =
      target[0]?.target !== null &&
      Object.keys(target[0]?.target || {}).length !== 0
        ? target[0]?.target["bl_fi_mst_branch"]
        : [];
    });

    let formData = {
      "limit" : null,
      "orderBy" : "code",
      "order" : "ASC"
    }

   this.subs.sink = this.dropDownService.get('branch', formData, AppConfig.apiVisa)
    .pipe(
      map((resolved) => {
        if (this.branchTargets?.length > 0) {
          this.filteredBranches = resolved.data.filter((record) => this.branchTargets.includes(record.guid));
          this.newFilteredBranches = resolved.data.filter((record) => this.branchTargets.includes(record.guid));
        } else {
          this.filteredBranches = resolved.data; 
          this.newFilteredBranches = resolved.data
        }
      })
    ).subscribe();
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || "").trim();
    // Add our branch
    if (value) {
      this.branches.push(value);
    }

    // Clear the input value
    event.input.value = "";

    this.branchControl.setValue(null);

    this.viewModelStore.dispatch(
      this.ColumnViewActions.setAdvanceSearch_BranchField({
        branches: this.branches,
      })
    );
  }

  remove(branch: string): void {
    const index = this.branches.indexOf(branch);

    if (index >= 0) {
      this.branches.splice(index, 1);
    }
    this.viewModelStore.dispatch(
      this.ColumnViewActions.setAdvanceSearch_BranchField({
        branches: this.branches,
      })
    );
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    console.log(event.option);
    this.branches.push(event.option.value);
    this.branchInput.nativeElement.value = "";
    this.branchControl.setValue(null);
  }

  filterBranch(filterValue: string) {
    filterValue = filterValue?.trim().toLowerCase(); // Remove whitespace and make it lowercase
    this.filteredBranches = this.newFilteredBranches.filter((option) =>
      option.code.toLowerCase().includes(filterValue)
    );
  }

  optionClicked(event: Event, branch: any) {
    event.stopPropagation();
    this.toggleSelection(branch);
  }

  toggleSelection(branch: any) {
    console.log(branch);
    branch.selected = !branch.selected;
    this.branchInput.nativeElement.value = "";
    if (branch.selected) {
      this.branches.push(branch);
    } else {
      const i = this.branches.findIndex((value) => value.guid === branch.guid);
      this.branches.splice(i, 1);
    }
    this.viewModelStore.dispatch(
      this.ColumnViewActions.setAdvanceSearch_BranchField({
        branches: this.branches,
      })
    );
  }

  onReset() {
    this.branches = [];
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
